import { OrderedParallelEnumerable } from "../OrderedParallelEnumerable.js";
export const orderByDescendingAsync = (source, keySelector, comparer) => {
    return OrderedParallelEnumerable.generateAsync(source, keySelector, false, comparer);
};
